// extracted by mini-css-extract-plugin
export default {"button":"Button_button__g9p4b","primary":"Button_primary__fg6e1"};